import { cn } from '@/utils/commonUtil'
import { createIcon } from '@/utils/factoryUtil/createIcon'

import styles from './SVGCommonLoaderDots.module.scss'

export const SVGCommonLoaderDots = createIcon('SVGCommonLoaderDots', ({ className, ...props }) => (
  <svg className={cn(styles.container, className)} viewBox='0 0 100 100' {...props}>
    <circle className={styles.left} cx='18' cy='50' r='12' />
    <circle className={styles.middle} cx='50' cy='50' r='12' />
    <circle className={styles.right} cx='82' cy='50' r='12' />
  </svg>
))
